import { useQuery } from '@pylot-data/hooks/use-query'
import type { UseQuerySwrOptions } from '@pylot-data/hooks/use-query'
import type {
    CategoryTree,
    CategoryResult,
    Maybe
} from '@pylot-data/pylotschema'
import type { SWRConfiguration } from 'swr'
import { RequestInit } from '@vercel/fetch'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { navigationMenuWithCMSBlocks } from './graphql/navigationMenuWithCMSBlocks'
import { MenuPreloadVariables } from '@preload/graphql/getConfig.d'

/** GET de GraphQL lo cachea Magento/Varnish; POST + no-store pide el árbol vivo. */
export const NAV_MENU_FETCH_OPTIONS: RequestInit = {
    method: 'POST',
    cache: 'no-store'
}

export type NavigationResponse = {
    navigation?: Maybe<CategoryTree>
    isValidating: boolean
    error?: GraphQLError
}

export const useNavMenu = (
    variables?: Maybe<MenuPreloadVariables>,
    swrOptions?: UseQuerySwrOptions,
    fetchOptions: RequestInit = NAV_MENU_FETCH_OPTIONS
): NavigationResponse => {
    const { data, error, isValidating } = useQuery<
        Maybe<MenuPreloadVariables>,
        { categories: CategoryResult }
    >(navigationMenuWithCMSBlocks, variables, swrOptions, fetchOptions)
    const categories = data?.data?.categories.items ?? []

    return {
        navigation: categories.length > 0 ? categories[0] : null,
        isValidating,
        error
    }
}
